// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".artificial-streaming-report-upload{position:relative}.artificial-streaming-report-upload__label{float:left;margin-bottom:10px;width:100%}.artificial-streaming-report-upload__label span{float:left;width:15%}.artificial-streaming-report-upload__label .cform__input-group{float:left;width:85%}", ""]);
// Exports
module.exports = exports;
